import { MobiDocument } from './MobiDocument';

export class PlageFonctionnementDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private intitule : string;
    private abreviation : string;
    private aslh : boolean;
    private periscolaire : boolean;
    private sejour : boolean;
    private restauration : boolean;
    private atelier : boolean;
    private secteurjeune : boolean;
    private accueil : boolean;
    private neplusafficher : boolean;
    private repas : boolean;

    public constructor (plagefonctionnement : any){
        super()
        this._id = plagefonctionnement._id;
        this._rev = plagefonctionnement._rev;
        this.id = plagefonctionnement.id;
        this.intitule = plagefonctionnement.intitule;
        this.abreviation = plagefonctionnement.abreviation;
        this.aslh = plagefonctionnement.aslh;
        this.periscolaire = plagefonctionnement.periscolaire;
        this.sejour = plagefonctionnement.sejour;
        this.restauration = plagefonctionnement.restauration;
        this.atelier = plagefonctionnement.atelier;
        this.secteurjeune = plagefonctionnement.secteurjeune;
        this.accueil = plagefonctionnement.accueil;
        this.neplusafficher = plagefonctionnement.neplusafficher;
        this.repas = plagefonctionnement.repas;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getAbreviation(): string {
        return this.abreviation;
    }

    public setAbreviation(abreviation: string): void {
        this.abreviation = abreviation;
    }

    public isAslh(): boolean {
        return this.aslh;
    }

    public setAslh(aslh: boolean): void {
        this.aslh = aslh;
    }

    public isPeriscolaire(): boolean {
        return this.periscolaire;
    }

    public setPeriscolaire(periscolaire: boolean): void {
        this.periscolaire = periscolaire;
    }

    public isSejour(): boolean {
        return this.sejour;
    }

    public setSejour(sejour: boolean): void {
        this.sejour = sejour;
    }

    public isRestauration(): boolean {
        return this.restauration;
    }

    public setRestauration(restauration: boolean): void {
        this.restauration = restauration;
    }

    public isAtelier(): boolean {
        return this.atelier;
    }

    public setAtelier(atelier: boolean): void {
        this.atelier = atelier;
    }

    public isSecteurjeune(): boolean {
        return this.secteurjeune;
    }

    public setSecteurjeune(secteurjeune: boolean): void {
        this.secteurjeune = secteurjeune;
    }

    public isAccueil(): boolean {
        return this.accueil;
    }

    public setAccueil(accueil: boolean): void {
        this.accueil = accueil;
    }

    public isNeplusafficher(): boolean {
        return this.neplusafficher;
    }

    public setNeplusafficher(neplusafficher: boolean): void {
        this.neplusafficher = neplusafficher;
    }

    public isRepas(): boolean {
        return this.repas;
    }

    public setRepas(repas: boolean): void {
        this.repas = repas;
    }




}